<template>
        <div class="crumb">
            <span><i class="iconfont icon-shouye"></i></span> / <span>{{$t('DataSerch.dataSearch')}}</span>
        </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .crumb{

        width: 1200px;
        margin:24px auto 24px;
        // height: 22px;
        // padding: 24px 0;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        span{
            i{
                margin-right: 8px;
            }
            margin: 0 6px;
        }
    }
</style>